import React from "react";
import { Image, Statistic } from "antd";
import { Section1, Section3, Section4, Section5 } from "../../txtLoginQR.js";

// 🛠️ แก้ไข: ดึง Countdown ออกมาจาก Statistic ให้ถูกต้อง (ไม่มีระบบ Timer)
const { Timer } = Statistic;

export const LoginQRComponent = ({ data, isExpired, handleCountdownFinish, t, initialTimeLeft }) => {
    const stylesObject = {
        root: {
            border: '2px solid #10b981',
            borderRadius: 16,
            padding: 14,
        },
    };


    if (!data) {
        return <p className="text-center text-gray-500">{t("No Data")}</p>;
    }

    const sharedProps = {
        src: data?.qrCode,
        width: 160,
        alt: 'QRcode',
        preview: !isExpired,

    };
    // แตกตัวแปรออกมาใช้งานอย่างปลอดภัย


    return (
        <div className="flex flex-col items-center text-center p-4 pt-6">

            <Section1 t={t} />

            <div className="d-flex justify-center p-3 rounded-2xl mb-6">
                <Image {...sharedProps} style={{
                    ...stylesObject.root,
                    filter: isExpired ? 'blur(6px)' : 'none',
                    transition: 'filter 0.3s ease'
                }} />
            </div>

            {/* ส่วนจัดระเบียบตัวนับถอยหลังด้วย Tailwind CSS */}
            <div className="mb-6 h-12 flex justify-center items-center">
                {!isExpired ? (
                    <div className="flex items-center gap-1 text-sm text-gray-500">
                        <Section3 t={t} />
                        {/* 🛠️ แก้ไข: เปลี่ยนจาก Timer มาเป็น Countdown และปรับรูปแบบการส่งค่า */}
                        <Timer
                            value={parseInt(initialTimeLeft)}
                            type="countdown"
                            onFinish={handleCountdownFinish}
                            format="mm:ss"
                            valueStyle={{ fontSize: '14px', color: '#10b981', fontWeight: '600', display: 'inline-block' }}
                        />
                    </div>
                ) : (
                    <Section4 t={t} />
                )}
            </div>

            <div className="mt-3 w-full bg-gray-50 rounded-xl p-4 border border-gray-100">
                <Section5 t={t} />
            </div>

        </div>
    );
};